import { Button, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { paymentServices } from 'src/services/payment/Payment.service'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ArrayInputPaymentsPerProduct } from './ArrayInputPaymentsPerProduct'
import { PaymentTypesContext } from './PaymentTypesContext'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { businessUnitPerProductServices } from 'src/services/payment/businessUnitPerProduct/BusinessUnitPerProduct.service';

export const ArrayInputPayments = ({businessUnitId}) => {
    const notify = useNotify()
    const translate = useTranslate()
    const [isTableLoading, setIsTableLoading] = useState(false)
    const [paymentInstances, setPaymentInstances] = useState([])
    const [paymentPerProductScreen, setIspaymentPerProductScreen] = useState(false)
    const [paymentToEdit, setPaymentToEdit] = useState(null)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [productToDelete, setProductToDelete] = useState(null)
    const [loadingDelete, setLoadingDelete] = useState(false)
    const [isShow, setIsShow] = useState(false)
    const [totalProductOptions, setTotalProductOptions] = useState([])
    const { 
            paymentTypes, 
            setPaymentTypes, 
            setAvailablePaymentTypes,
            setAvailableProducts 
        } = useContext(PaymentTypesContext);

    useEffect(()=>{
        if(!paymentPerProductScreen){
            getPaymentInstances()
            getPaymentType()
            getProductOptions()
        }
    },[paymentPerProductScreen])

    const getProductOptions = () =>{
        businessUnitPerProductServices.getProductsByBusinessUnit(businessUnitId).then(res=>{
            setTotalProductOptions(res.map(item=>{return {id:item.product_id, label:item.product_relation.long_name}}))
        })
    }

    useEffect(()=>{
        if(!paymentPerProductScreen){
            setPaymentToEdit(null)
        }
        if(!paymentToEdit){
            setAvailableProducts(totalProductOptions.filter(option=>!(paymentInstances.map(pay=>pay[0].product_id)).includes(option.id)))
        } else {
            setAvailableProducts(totalProductOptions)
        }
    },[paymentPerProductScreen])

    const deletePaymentInstances = async () =>{
        setLoadingDelete(true)
        let finishCount = 0
        let okCount = 0
        for(let instance of productToDelete){
            await businessUnitPerProductServices.deleteProductsByBusinessUnit(instance.id).finally(()=>{
                finishCount ++
            }).then(()=>{
                okCount ++
            })
        }
        if(finishCount === productToDelete.length){
            setLoadingDelete(false)
        }
        if(okCount === productToDelete.length){
            setOpenConfirmDialog(false)
            notify('ra.message.payment_instance_deleted', {type:'success'})
            getPaymentInstances()
        } else {
            notify('ra.message.payment_instance_delete_error', {type:'error'})
        }
    }

    useEffect(()=>{
        if(confirmDelete){
            deletePaymentInstances()
        }
    },[confirmDelete])

    useEffect(()=>{
        if(paymentToEdit){
            setIspaymentPerProductScreen(true)
        }
    },[paymentToEdit])

    const getPaymentType = () =>{
        paymentServices.getAllActivePaymentTypes().then(res=>{
            setPaymentTypes(res)
            setAvailablePaymentTypes(res)
        })
    }


    const processPaymentInstances = (data) =>{
        const groupInstances = data.reduce((acc, item) => {
            const key = item.product_id;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
        return Object.values(groupInstances)
    }

    const getPaymentInstances = () =>{
        setIsTableLoading(true)
        businessUnitPerProductServices.getByBusinessUnit(businessUnitId).then((res)=>{
            const processedResponse = processPaymentInstances(res)
            setPaymentInstances(processedResponse)
        }).finally(()=>{
            setIsTableLoading(false)
        })
    }

    const onDeletePayments = (row) => {
        setOpenConfirmDialog(true)
        setProductToDelete(row)
    }

    const getPaymentTypeName = (id) =>{
        return paymentTypes.find(item=>item.id === id)?.long_name
    }
  return (
    <div style={{width:'100%'}}>
        {
            paymentPerProductScreen ?
                <ArrayInputPaymentsPerProduct 
                    setIspaymentPerProductScreen = {setIspaymentPerProductScreen} 
                    businessUnitId={businessUnitId} 
                    payment={paymentToEdit} 
                    isShow={isShow}
                />
            :
            <>
                <label>
                    {'Instancias de pago'}
                </label>
                <TableContainer>
                    <Table>
                    <TableHead>
                        <TableRow>
                        <TableCell>{translate('ra.field.product')}</TableCell>
                        <TableCell>{translate('ra.field.online_payments')}</TableCell>
                        <TableCell>{translate('ra.field.payment_methods')}</TableCell>
                        <TableCell></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {isTableLoading ? (
                        <TableRow>
                            {[...Array(4)].map((_, i) => (
                            <TableCell key={i}>
                                <Skeleton variant='rectangular' width={'100%'} height={20} />
                            </TableCell>
                            ))}
                        </TableRow>
                        ) :
                        (paymentInstances?.map((row, i) => (
                            <TableRow key={i}>
                                <TableCell>{row[0].product_name}</TableCell>
                                <TableCell style={{textAlign:'center'}}>
                                    {
                                        row[0].is_active ?
                                        <DoneIcon style={{color:'white', backgroundColor:'limegreen', borderRadius:'3px'}} />
                                            :
                                        <CloseIcon/>
                                    }
                                </TableCell>
                                <TableCell>
                                    <label>
                                    {
                                        (row?.map(item=>getPaymentTypeName(item.payment_type_id))).join(', ')
                                    }
                                    </label>
                                </TableCell>
                                <TableCell>
                                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                                        <VisibilityIcon 
                                            color='info' 
                                            style={{cursor:'pointer'}}
                                            onClick={()=>{setPaymentToEdit(row);setIsShow(true)}}
                                        />
                                        <EditIcon 
                                            onClick={()=>{setPaymentToEdit(row);setIsShow(false)}}
                                            color='info' 
                                            style={{cursor:'pointer'}}
                                        />
                                        <DeleteIcon 
                                            color='error' 
                                            style={{cursor:'pointer'}}
                                            onClick={()=>onDeletePayments(row)}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                            ))
                        )}
                    </TableBody>
                    </Table>
                </TableContainer>
                <Button 
                    onClick={()=>{setIspaymentPerProductScreen(true)}}
                    variant='outlined' 
                    style={{display:'flex', flexDirection:'row', marginTop:'15px'}}>
                    <AddIcon/>
                    {translate('ra.action.add_payment_instance')}
                </Button>
                <ConfirmationDialog
                    setOpen={setOpenConfirmDialog}
                    open={openConfirmDialog}
                    loadingModalButton={loadingDelete}
                    buttonCancel={translate('ra.action.cancel')}
                    buttonConfirmText={translate('ra.action.acept')}
                    setConfirm={setConfirmDelete}
                    contentText={translate('ra.message.confirmation_delete_paymentes_product', {product:productToDelete ? productToDelete[0]?.product_name : ''})}
                />
            </>
        }
    </div>
  )
}